import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import {QdProfileData} from '../models/qd-profile-data';
import {OrderForm} from '../models/order-form';
import {MarketDataLedgersResponse} from '../models/market-data-ledger';
import {PopConfigurationGroup} from '../models/pop-configuration-group';

export interface AddpRequestDetailsResponse {
  requestId: string;
  status: string;
  type: string;
  createdAt?: string | null;
  requester?: {
    name?: string | null;
    email?: string | null;
  } | null;
  primaryContact?: {
    name?: string | null;
    email?: string | null;
  } | null;
  payload: Record<string, any>;
}

@Injectable()
export class OrderFormService {

  constructor(private httpClient: HttpClient) {
  }

  getOrderForms(uniqid: string, service: string): Observable<QdProfileData[]> {
    return this.httpClient.get<QdProfileData[]>(environment.baseUrlWs + '/api/qd-profile-order-forms?company.uniqid='
      + uniqid + '&service=' + service);
  }

  exportAsExcel(uniqid: string, service: string, uuidList: string[]): Observable<any[]> {
    const data = {'company.uniqid': uniqid, 'serviceName': service, 'itemUuids': uuidList};
    return this.httpClient.post<any>(environment.baseUrlWs + '/api/qd-profile-export', data);
  }

  getOrderFormsItems(criteria: any): Observable<any> {
    return this.httpClient.post<any>(environment.baseUrlWs + '/api/qd-profile-items', criteria);
  }

  getMarketDataOrderForms(uniqid: string): Observable<OrderForm[]> {
    return this.httpClient.get<OrderForm[]>(environment.baseUrlWs + '/api/market-data-order-forms?company.uniqid=' + uniqid);
  }

  getLedgerOrderForms(companyId?: number): Observable<MarketDataLedgersResponse> {
    let params = new HttpParams();
    if (typeof companyId === 'number') {
      params = params.set('companyId', companyId.toString());
    }
    return this.httpClient.get<MarketDataLedgersResponse>(environment.baseUrlWs + '/api/ledger/order-form', { params });
  }

  downloadLedgerOrderFormPdf(orderFormId: number, companyId?: number): Observable<HttpResponse<Blob>> {
    let params = new HttpParams();
    if (typeof companyId === 'number') {
      params = params.set('companyId', companyId.toString());
    }
    return this.httpClient.get(environment.baseUrlWs + '/api/ledger/order-form/' + orderFormId + '/pdf', {
      observe: 'response',
      responseType: 'blob',
      params
    });
  }

  cancelAddpRequest(requestId: string): Observable<void> {
    return this.httpClient.post<void>(`${environment.baseUrlWs}/api/addp-requests/${requestId}/cancel`, {});
  }

  getAddpRequestDetails(requestId: string): Observable<AddpRequestDetailsResponse> {
    return this.httpClient.get<AddpRequestDetailsResponse>(`${environment.baseUrlWs}/api/addp-requests/${requestId}`);
  }

  cancelLedgerItem(itemUuid: string): Observable<void> {
    return this.httpClient.post<void>(`${environment.baseUrlWs}/api/ledger/items/${itemUuid}/cancel`, {});
  }
  getMulticasts(uniqid: string, service: string): Observable<any> {
    return this.httpClient.get<any>(environment.baseUrlWs + '/api/qd-profile-multicasts?company.uniqid='
      + uniqid + '&service=' + service);
  }

  getPopConfigs(uniqid: string, service: string): Observable<{ service: string, pops: PopConfigurationGroup[] }> {
    return this.httpClient.get<{ service: string, pops: PopConfigurationGroup[] }>(environment.baseUrlWs
      + '/api/customer-pop-configurations?company.uniqid=' + uniqid + '&service=' + service);
  }

  getTimeSyncDataProfile(uniqid: string): Observable<QdProfileData[]> {
    return this.httpClient.get<QdProfileData[]>(environment.baseUrlWs + '/api/time-sync-data-profile?company.uniqid=' + uniqid);
  }
}
